/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import VueRouter, { Route, RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';
import { routeClone } from '@/utils/navigation';
import { standardizePostsRoute } from '@/utils/secret';

export default [
  {
    name: 'secret',
    path: '/secret',
    meta: { tabbar: 'secret/secret' },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'secret_list' },
    children: [
      {
        name: 'secret_group_filters',
        path: 'group-filters/:group',
        meta: { title: '选择' },
        component: () => import('@/views/secret/group-filters.vue'),
      },
      {
        name: 'secret_detail',
        path: 'posts/:id(\\d+)',
        meta: { auth: [AUTH_STATE.LOGGED_IN, AUTH_STATE.GUEST], title: '秘密详情' },
        component: () => import('@/views/secret/detail'),
      },
      {
        name: 'secret_game_list',
        path: 'game/list',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '游戏圈', tabbar: 'secret/room' },
        component: () => import('@/views/secret/game_list'),
      },
      {
        name: 'game_add',
        path: '/games/add',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '添加游戏' },
        component: () => import('@/views/game/game_add'),
      },
      {
        name: 'secret_room_list',
        path: 'room/list',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '版块列表', tabbar: 'secret/room' },
        component: () => import('@/views/secret/room_list'),
      },
      {
        name: 'secret_room_config',
        path: 'room/:id(\\d+)?/config',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '版块设置' },
        component: () => import('@/views/secret/room-config.vue'),
      },
      {
        name: 'secret_create',
        path: 'create',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '\u200e' },
        component: () => import('@/views/secret/create.vue'),
      },
      {
        name: 'secret_create_simple',
        path: 'create/simple',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '问管理' },
        component: () => import('@/views/secret/create-simple.vue'),
      },
      {
        name: 'secret_search',
        path: 'search',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '搜索帖子' },
        component: () => import('@/views/secret/search.vue'),
      },
      {
        name: 'secret_lucky',
        path: 'lucky',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '沧海拾遗' },
        component: () => import('@/views/secret/lucky.vue'),
      },
      {
        name: 'secret_tops',
        path: 'tops',
        meta: { title: '海鳗排行榜' },
        component: () => import('@/views/secret/tops'),
      },
      {
        name: 'secret_tops_detail',
        path: 'tops/detail/:type',
        meta: { title: '海鳗排行榜' },
        component: () => import('@/views/secret/tops_detail'),
      },
      {
        name: 'subscription_config',
        path: 'subscription/config',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '管理订阅' },
        component: () => import('@/views/secret/subscription_config'),
      },
      {
        name: 'secret_list',
        // 如果 p0=posts 就表示底部 TABBAR 停在首页
        // e.g: posts/{filter}, game/{name}, room/{id}, topic/{id}, city/{name}, room/mark/{id}
        path: ':p0?/:p1?/:p2?',
        meta: {
          auth: AUTH_STATE.LOGGED_IN,
          title: '',
          tabbar: (route: Route) => {
            const type = standardizePostsRoute(route).params.p0;
            return type === 'game' || type === 'room' ? 'room' : 'secret';
          },
          tabbarAction: (route: Route, router: VueRouter): boolean => {
            const type = standardizePostsRoute(route).params.p0;
            if (type === 'game' || type === 'room') {
              return false;
            }
            const routeInfo = routeClone(route);
            routeInfo.query.navigate = 'true';
            router.push(routeInfo);
            return true;
          },
        },
        component: () => import('@/views/secret/list'),
      },
    ],
  },
] as RouteConfig[];
